export default __webpack_public_path__ + "static/media/SkelascentBanner.db115ade.png";